module.exports = __webpack_public_path__ + "img/Gibraltar.238c2004.svg";